import { Link, type SxProps, type Theme } from "@mui/material";
import type { MouseEvent, ReactNode } from "react";

import { telephoneHref } from "../../lib/crm";
import { callRecord } from "../../lib/telephony/callRecord";
import { useCrmRecord } from "../crm/CrmRecordContext";
import { usePhone } from "./PhoneProvider";
import { useDialNumber } from "./useDialNumber";

type PhoneNumberLinkProps = {
  number: string;
  children?: ReactNode;
  sx?: SxProps<Theme>;
  "aria-label"?: string;
};

/** A phone number that dials through the portal phone when it is ready and is a plain tel: link otherwise. */
export const PhoneNumberLink = ({ number, children, sx, "aria-label": ariaLabel }: PhoneNumberLinkProps) => {
  const { status, activeCall, openPanel } = usePhone();
  const dialNumber = useDialNumber();
  const record = useCrmRecord();
  const phoneReady = status?.kind === "ready" && !activeCall;

  const call = (event: MouseEvent) => {
    event.preventDefault();
    openPanel();
    void dialNumber(number, callRecord(record));
  };

  return (
    <Link
      href={telephoneHref(number)}
      onClick={phoneReady ? call : undefined}
      sx={sx}
      aria-label={ariaLabel}
      data-testid="crm-phone-link"
    >
      {children ?? number}
    </Link>
  );
};
